import _ from "underscore";

import React from 'react';

import createReactClass from 'create-react-class';

var SearchBox = createReactClass({
  displayName: 'SearchBox',

  render: function() {
    return (
      <div className='multiselect-dropdown-searchbox'>
        <i className='material-icons' htmlFor='filter-string'>search</i>
        <input
          className='form-control'
          type='text'
          name='filter-string'
          onChange={this._handleChangeDebounce}
          ref={(r) => { this._searchQuery = r; }}></input>
      </div>
    );
  },

  _handleChangeDebounce: _.debounce(function(event) {
    this.props.onChangeCallback(this._searchQuery.value);
  }, 200)
});

export default SearchBox;
